export default __webpack_public_path__ + "static/media/ic-candidate-management-2.103c138b.svg";